<template>
  <wrapper>

      <fragment v-if="user_activation">
      <div class="row center" v-if="loading">
          <pre-loader></pre-loader>
      </div>
      <div class="row" v-else>
            <div class="row">
                <div class="col l4 m12 s10 offset-s1">
                     <notice-board></notice-board>
                </div>
                <div class="col l6 m12 s12 offset-l1 offset-m1">
                    <h6 style="margin-top:50px;"><b> အွန်လိုင်းသင်တန်းစည်းကမ်း</b></h6>
                    <ul>
                        <li>၁။ သင်ခန်းစာများကို အချိန်မှန်သင်ယူရမည်။</li>
                        <li>၂။ အိမ်စာများကို ပုံမှန် ပေးပို့ရမည်။</li>
                        <li>၃။ သင်တန်းမှ စစ်ဆေးသော စာမေးပွဲများကို မပျက်မကွက်ဖြေဆိုရမည်။ </li>
                    </ul>
                    <h6 style="margin-top:50px;"><b>သင်တန်းကျောင်းအချက်အလက်များနှင့်စပ်လျဉ်း၍</b></h6>
                    <ul>
                    <li>သင်တန်းကျောင်း၏ဝက်ဘ်ဆိုက်စာမျက်နှာတွင် ဖော်ပြထားသော အချက်အလက်များအားလုံးသည်</li>
                    <li>ခါခဲဟာရှိသင်တန်းကျောင်း၏ မူပိုင်ဖြစ်ပါသည်။ သင်တန်းကျောင်း၏ ခွင့်ပြုချက်မရှိဘဲ </li>
                    <li>တစိတ်တပိုင်းဖြစ်စေ အားလုံးဖြစ်စေ ကူးယူဖော်ပြခြင်း၊ <u><b>မျှဝေခြင်းကို လုံးဝ ခွင့်မပြုပါ။</b></u></li>
                    </ul>
                </div>
            </div>
            <div class="row">
            <div class="col l10 m12 s10 offset-s1">
                 <div class="row box_container">
                    <h6 class="box_title">My Classes</h6>
                    <class></class>
                </div>
                 <div class="row box_container">
                    <exam></exam>
                </div>
            </div>
            </div>
         
      </div>
      </fragment>
      <div class="row center" style="padding-top:50px;" v-else>
            <h5 style="margin-bottom:30px;" class="red-text">Your acccount is not activated yet.You need to change your password</h5>
            <router-link class="btn" to="/change-pw">Click Here to change password</router-link>

      </div>
      
  </wrapper>
</template>
<script>
import _Class from '@/components/Home/Class/Class.vue';
import Exam from '@/components/Home/Exam/Exam.vue';
import NoticeBoard from './NoticeBoard/NoticeBoard.vue';
export default {
  name: "Home",
  components: 
  {
      "class":_Class,
      "exam":Exam,
      'notice-board':NoticeBoard,
  },
  mounted()
  {
      if (this.user_activation)
      {
          this.$store.dispatch("get_home_data",{});
      }
      
  },
  computed: 
  {
    
      loading()
      {
          return this.$store.getters.class_loading;
      },
      user_activation()
      {
          return this.$store.getters.user_activation;
      }
  }
};
</script>
<style lang="scss" scoped>
        @import "@/style/colors.scss";
    .box_container
    {
        margin-top:30px;
    }

    .box_container h6 
    {
        color:#005555;
        padding-left:20px;
        border:none !important;
    }

    .box_container h6 
    {
        color:white !important;
        background:#e38b00;
        width:200px !important;
        padding:20px;
        font-size:18px !important;
        border-radius: 150px;
        text-align: center;
        text-transform: uppercase;
    }

    ul {
        li  
        {
            margin-bottom:10px;
        }
    }

   

</style>